import { CirclePlus } from "lucide-react";

interface ForexFiguresProps {
  onClick: () => void;
  currencies: any;
}

export default function ForexFigures({ onClick, currencies }: ForexFiguresProps) {
  // Find the latest created_at
  const latestDate = currencies?.length
    ? new Date(
        Math.max(...currencies.map((c: any) => new Date(c.created_at).getTime()))
      )
    : null;

  // Format as dd/mm/yyyy
  const formattedDate = latestDate
    ? `${latestDate.getDate().toString().padStart(2, "0")}/${(
        latestDate.getMonth() + 1
      )
        .toString()
        .padStart(2, "0")}/${latestDate.getFullYear()}`
    : "—";

  return (
    <div className="flex items-center justify-start gap-x-4 my-4">
      <button
        className="w-[280px] h-[130px] bg-card flex items-center justify-center gap-x-4 rounded-xl p-4"
        onClick={onClick}
      >
        <CirclePlus className="text-white" size={24} />
        <div className="flex flex-col items-start">
          <h1 className="text-white text-3xl font-bold">New Currency</h1>
          <p className="text-white text-xs">Add a supported currency</p>
        </div>
      </button>

      <div className="w-[260px] h-[130px] bg-card flex flex-col items-start justify-center rounded-xl p-4">
        <h1 className="text-white text-3xl font-bold">{currencies.length}</h1>
        <p className="text-white text-xs">Supported Currencies</p>
      </div>

      <div className="w-[260px] h-[130px] bg-card flex flex-col items-start justify-center rounded-xl p-4">
        <h1 className="text-white text-3xl font-bold">{currencies.length}</h1>
        <p className="text-white text-xs">Active Currencies</p>
      </div>

      <div className="w-[260px] h-[130px] bg-card flex flex-col items-start justify-center rounded-xl p-4">
        <h1 className="text-white text-3xl font-bold">4.4%</h1>
        <p className="text-white text-xs">Overall Daily %</p>
      </div>

      <div className="w-[260px] h-[130px] bg-card flex flex-col items-start justify-center rounded-xl p-4">
        <h1 className="text-white text-3xl font-bold">{formattedDate}</h1>
        <p className="text-white text-xs">Last Updated</p>
      </div>
    </div>
  );
}
